import React from 'react'
import { getdata,cartCount } from './Med';
import ShopHeader from './ShopHeader';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
    const aarr=getdata();
    console.log("DATA",aarr)
  
    const navigate=useNavigate();
    const pay=()=>{
       navigate('/payment')
    }

  return (
    <>
    <ShopHeader/>
    <div className='row'>
       <h1 className='h1t'>CART ITEMS</h1>
       <h4 className='h1t'>LIST OF ITEMS IN YOUR CART :{cartCount()} </h4>

    </div>
    <div className='row'>         
     {aarr.map((Object)=>{
        return(
            <div class="card cardstyle">
            <img class="card-img-top mt-2" src={Object.img} alt="Card  cap" />
            <div class="card-body">
                <h5 class="card-title">{Object.title}</h5>
                <button onClick={pay} class="btn btn-primary">Shop Now</button>
            </div>
        </div>
        )
       }
      ) }</div>
      </>
  )
}

export default Cart;